import "core-js/modules/es.array.push.js";
import { useRouter, useRoute } from "vue-router";
export default {
  name: "ProtocolManagement",
  setup() {
    const router = useRouter();

    //前往目标页面
    const toTargetPage = (path, url) => router.push({
      path,
      query: {
        url
      }
    });
    return {
      toTargetPage
    };
  }
};